// extracted by mini-css-extract-plugin
export default {"spaced":"styles_spaced__g0hgB","text":"styles_text__ptRGY","contain":"styles_contain__+XFGl","icon":"styles_icon__gRT6L"};